import {NotifyHelper} from "../../../helpers/toast";
import {eNganHangActionsObj} from "../../action-types/ngan-hang/INganHangActions";
import {generateActionForKey, generateActions} from "../generateActions";

export const nganHangActions = {
    ...generateActions(eNganHangActionsObj, "NGAN_HANG"),
    ...generateActionForKey(
        eNganHangActionsObj,
        "NGAN_HANG",
        "SAVE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã cập nhật");
        }
    ),
    ...generateActionForKey(
        eNganHangActionsObj,
        "NGAN_HANG",
        "SAVE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eNganHangActionsObj,
        "NGAN_HANG",
        "DELETE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eNganHangActionsObj,
        "NGAN_HANG",
        "DELETE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eNganHangActionsObj,
        "NGAN_HANG",
        "GENQR_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eNganHangActionsObj,
        "NGAN_HANG",
        "TRA_SOAT_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
};
export default nganHangActions;
